import React from 'react';

const SheetCloseIcon = ({ className }) => (
    <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            d='M8.0293 21.75H14.0293C19.4593 21.75 21.7793 19.43 21.7793 14V8C21.7793 2.57 19.4593 0.25 14.0293 0.25H8.0293C2.5993 0.25 0.279297 2.57 0.279297 8V14C0.279297 19.43 2.5893 21.75 8.0293 21.75ZM14.0293 1.75C18.6393 1.75 20.2793 3.39 20.2793 8V14C20.2793 18.61 18.6393 20.25 14.0293 20.25H8.0293C3.4193 20.25 1.7793 18.61 1.7793 14V8C1.7793 3.39 3.4193 1.75 8.0293 1.75H14.0293Z'
            fill='#A2A0A2'
        />
        <path
            d='M8.0293 21.75C8.4393 21.75 8.7793 21.41 8.7793 21V1C8.7793 0.59 8.4393 0.25 8.0293 0.25C7.6193 0.25 7.2793 0.59 7.2793 1V21C7.2793 21.41 7.6093 21.75 8.0293 21.75Z'
            fill='#A2A0A2'
        />
        <path
            d='M15.0298 14.3099C15.2198 14.3099 15.4098 14.2399 15.5598 14.0899C15.8498 13.7999 15.8498 13.3199 15.5598 13.0299L13.5298 10.9999L15.5598 8.96988C15.8498 8.67988 15.8498 8.19988 15.5598 7.90988C15.2698 7.61988 14.7898 7.61988 14.4998 7.90988L11.9398 10.4699C11.6498 10.7599 11.6498 11.2399 11.9398 11.5299L14.4998 14.0899C14.6398 14.2399 14.8298 14.3099 15.0298 14.3099Z'
            fill='#A2A0A2'
        />
    </svg>
);

export { SheetCloseIcon };
